export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-interpolate/src/round.js
// module id = null
// module chunks = 